module.exports = __webpack_public_path__ + "static/img/icon_sj_hover.6d69106b.svg";